<template>
    <div class="jump-type">
        <el-row>
            <el-col :span="10">
                <el-form-item label="跳转类型：">
                    <el-select v-model="type" placeholder="请选择跳转类型" @change="changeType" style="min-width: 180px;">
                        <el-option v-for="item in jumpType" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12" :offset="1">
                <el-form-item label="url链接：" v-if="type == 1">
                    <el-input v-model="commonId" placeholder="请输入url链接" style="min-width: 180px;"
                        @blur="setCommonId"></el-input>
                </el-form-item>
                <el-form-item label="小程序页面路径：" v-if="type == 2">
                    <el-input v-model="commonId" placeholder="请输入页面路径" style="min-width: 180px;"
                        @blur="setCommonId"></el-input>
                </el-form-item>
                <el-form-item label="跳转文章ID：" v-if="type == 3">
                    <el-select v-model="commonId" placeholder="请选择跳转文章" style="min-width: 180px;" @change="setCommonId">
                        <el-option v-for="item in zxList" :key="item.id" :label="item.title" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="跳转频道页面ID：" v-if="type == 4">
                    <el-select v-model="commonId" placeholder="请选择跳转频道页面" style="min-width: 180px;"
                        @change="setCommonId">
                        <el-option v-for="item in pdList" :key="item.channelId" :label="item.channelName"
                            :value="item.channelId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="课程名称：" v-if="type == 5">
                    <el-select v-model="commonId" placeholder="请选择课程" style="min-width: 180px;" @change="setCommonId">
                        <el-option v-for="item in kwList" :key="item.id" :label="item.courseTitle" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="跳转直播ID：" v-if="type == 6">
                    <el-select v-model="commonId" placeholder="请选择跳转直播" style="min-width: 180px;" @change="setCommonId">
                        <el-option v-for="item in zbList" :key="item.id" :label="item.liveName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { jumpType } from '@/utils/commonData';
import { getLiveList, getArticleList, getChannelList, getCourseList } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';

var that = null;
export default {
    props: {
        jumpTypeVal: {
            type: String,
            default() {
                return '';
            }
        },
        commonIdVal: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            jumpType,
            type: this.jumpTypeVal,
            commonId: this.commonIdVal - 0 ? this.commonIdVal - 0 : this.commonIdVal,
            kwList: [],//课文列表
            zxList: [],//文章列表
            zbList: [],//直播列表
            pdList: [],//频道列表
        }
    },
    watch: {
        type(newVal, oldVal) {
            that.$emit('setType', newVal);
            that.commonId = '';
        },
        jumpTypeVal() {
            that.type = that.jumpTypeVal + '';
        },
        commonIdVal() {
            that.commonId = that.commonIdVal - 0 ? that.commonIdVal - 0 : that.commonIdVal;
        }
    },
    mounted() {
        that = this;
        that.getData();
    },
    methods: {
        getData() {
            if (that.kwList.length == 0) {
                that.getCourseList();
            }
            if (that.zxList.length == 0) {
                that.getArticleList();
            }
            if (that.zbList.length == 0) {
                that.getLiveList();
            }
            if (that.pdList.length == 0) {
                that.getChannelList();
            }
        },
        changeType() {
            that.commonId = '';
            that.getData();
        },
        setCommonId() {
            that.$emit('setCommonId', that.commonId + '');
        },
        reset() {
            console.log('reset');
            that.commonId = '';
            that.type = '';
        },
        getCourseList() {
            let info = {
                needPage: false
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            getCourseList(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('课程列表', ress);
                    that.kwList = ress;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        getArticleList() {
            let info = {
                listType: 0,
                classification: '',
                page: 1,
                pageSize: 10,
                title: '',
                needPage: true,
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            getArticleList(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('文章列表', ress);
                    that.zxList = ress.list;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        getLiveList() {
            let info = {
                categoryId: '',
                liveName: '',
                liveStatus: '',
                page: '',
                pageSize: '',
                startTime: '',
                needPage: false
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            getLiveList(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('直播列表', ress);
                    that.zbList = ress.list;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        getChannelList() {
            let info = {
                needPage: false
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            getChannelList(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('频道列表', ress);
                    that.pdList = ress;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
/deep/.el-form-item--small .el-form-item__content,
.el-form-item--small .el-form-item__label {
    width: 110px;
    flex-shrink: 0;
}
</style>